module.exports = __webpack_public_path__ + "static/media/MARUTI_F1.368e9721.txt";